import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
import properties from './properties'
import me from './me'
import marketStats from './market-stats'
import recentlySearchedProperties from './recently-searched-properties'
import reports from './reports'
import report from './report'
import metrics from './metrics'
import areas from './areas'
/**
* @see \App\Http\Controllers\Api\Internal\RequestProductAccessController::__invoke
* @see app/Http/Controllers/Api/Internal/RequestProductAccessController.php:20
* @route '/internal-api/request-product-access'
*/
export const requestProductAccess = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestProductAccess.url(options),
    method: 'post',
})

requestProductAccess.definition = {
    methods: ["post"],
    url: '/internal-api/request-product-access',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\RequestProductAccessController::__invoke
* @see app/Http/Controllers/Api/Internal/RequestProductAccessController.php:20
* @route '/internal-api/request-product-access'
*/
requestProductAccess.url = (options?: RouteQueryOptions) => {
    return requestProductAccess.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\RequestProductAccessController::__invoke
* @see app/Http/Controllers/Api/Internal/RequestProductAccessController.php:20
* @route '/internal-api/request-product-access'
*/
requestProductAccess.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestProductAccess.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\StreetViewController::__invoke
* @see app/Http/Controllers/Api/Internal/StreetViewController.php:16
* @route '/internal-api/street-view'
*/
export const streetView = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: streetView.url(options),
    method: 'post',
})

streetView.definition = {
    methods: ["post"],
    url: '/internal-api/street-view',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\StreetViewController::__invoke
* @see app/Http/Controllers/Api/Internal/StreetViewController.php:16
* @route '/internal-api/street-view'
*/
streetView.url = (options?: RouteQueryOptions) => {
    return streetView.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\StreetViewController::__invoke
* @see app/Http/Controllers/Api/Internal/StreetViewController.php:16
* @route '/internal-api/street-view'
*/
streetView.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: streetView.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\SaleValuationController::__invoke
* @see app/Http/Controllers/Api/Internal/SaleValuationController.php:18
* @route '/internal-api/sale-valuation'
*/
export const saleValuation = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: saleValuation.url(options),
    method: 'post',
})

saleValuation.definition = {
    methods: ["post"],
    url: '/internal-api/sale-valuation',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\SaleValuationController::__invoke
* @see app/Http/Controllers/Api/Internal/SaleValuationController.php:18
* @route '/internal-api/sale-valuation'
*/
saleValuation.url = (options?: RouteQueryOptions) => {
    return saleValuation.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\SaleValuationController::__invoke
* @see app/Http/Controllers/Api/Internal/SaleValuationController.php:18
* @route '/internal-api/sale-valuation'
*/
saleValuation.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: saleValuation.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\SearchController::__invoke
* @see app/Http/Controllers/Api/Internal/SearchController.php:24
* @route '/internal-api/search'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: search.url(options),
    method: 'post',
})

search.definition = {
    methods: ["post"],
    url: '/internal-api/search',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\SearchController::__invoke
* @see app/Http/Controllers/Api/Internal/SearchController.php:24
* @route '/internal-api/search'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\SearchController::__invoke
* @see app/Http/Controllers/Api/Internal/SearchController.php:24
* @route '/internal-api/search'
*/
search.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: search.url(options),
    method: 'post',
})

const internalApi = {
    properties: Object.assign(properties, properties),
    requestProductAccess: Object.assign(requestProductAccess, requestProductAccess),
    me: Object.assign(me, me),
    streetView: Object.assign(streetView, streetView),
    marketStats: Object.assign(marketStats, marketStats),
    saleValuation: Object.assign(saleValuation, saleValuation),
    recentlySearchedProperties: Object.assign(recentlySearchedProperties, recentlySearchedProperties),
    reports: Object.assign(reports, reports),
    search: Object.assign(search, search),
    report: Object.assign(report, report),
    metrics: Object.assign(metrics, metrics),
    areas: Object.assign(areas, areas),
}

export default internalApi